import React, { useState } from 'react';
class General extends React.Component {

    static resultData; // Results all fields


    setNameArr(names, headerData) {
        let res = headerData.filter(el => el.name === names);
        return res[0].dropdown[0];
    }

    valueField(e, setResult, result, id, currentFloor, resultMansard, setResultMansard) {
        let weightfloor = e.name.includes('weightfloor') ? e.name : false;
        let countfloor = e.name.includes('countfloor') ? e.name : false;
        let weight = e.name.includes('weight') ? e.name : false;
        let height = e.name.includes('height') ? e.name : false;
        let col = e.name.includes('col') ? e.name : false;
        let heigWall = e.name.includes('heigWall') ? e.name : false;
        let widthWallF = e.name.includes('widthWallF') ? e.name : false;
        let heigWallF = e.name.includes('heigWallF') ? e.name : false;
         

        if (currentFloor){
            switch (e.name){
                case heigWall:
                    setResultMansard({...resultMansard, [e.name + `=?=${id}`]: parseFloat(e.value) })
                    break;
                case widthWallF:
                    setResultMansard({...resultMansard, [e.name + `=?=${id}`]: parseFloat(e.value) })
                    break;
                case heigWallF:
                    setResultMansard({...resultMansard, [e.name + `=?=${id}`]: parseFloat(e.value) })
                    break;
                case weight:
                    setResultMansard({...resultMansard, [e.name + `=?=${id}`]: parseFloat(e.value) })
                    break;
                case height:
                    setResultMansard({...resultMansard, [e.name + `=?=${id}`]: parseFloat(e.value) })
                    break;
                case col:
                    setResultMansard({...resultMansard, [e.name + `=?=${id}`]: parseFloat(e.value) })
                    break;   
                default:
                    break;
            }
        } else {
            switch (e.name){
                case weight:
                    setResult({...result, [e.name + `=?=${id}`]: parseFloat(e.value) })
                    break;
                case height:
                    setResult({...result, [e.name + `=?=${id}`]: parseFloat(e.value) })
                    break;
                case col:
                    setResult({...result, [e.name + `=?=${id}`]: parseFloat(e.value) })
                    break;     
                default:
                    break;
            }
        }

        switch (e.name) {
            case 'dlina':
                setResult({...result, dlina: parseFloat(e.value) })
                break;
            case 'shirina':
                setResult({...result, shirina: parseFloat(e.value) })
                break;
            case 'dlinaV':
                setResult({...result, dlinaV: parseFloat(e.value) })
                break;
            case 'tolshinaN':
                setResult({...result, tolshinaN: parseFloat(e.value) })
                break;
            case 'tolshinaV':
                setResult({...result, tolshinaV: parseFloat(e.value) })
                break;
            case 'dlinaOb':
                setResult({...result, dlinaOb: parseFloat(e.value) })
                break;
            case 'tolshinaP':
                setResult({...result, tolshinaP: parseFloat(e.value) })
                break;
            case weightfloor:
                setResult({...result, [e.name + `=?=${id}`]: parseFloat(e.value) })
                break;
            case countfloor:
                setResult({...result, [e.name + `=?=${id}`]: parseFloat(e.value !== '' ? e.value : 1) }) // Количество этажей одного типа
                break;
                 
            default:
                break;
        }
        this.resultData = result;

    }

    returnObjectValueMansard(){
        
    }

    returnObjectValue(results) {
        /*
          Функция преобразование объекта в массив 
          results = {params: value} -> 
          [
            {
                id{params}: 
                    [0: top: [value{value}], 
                    1: [value{value}]]
            }
          ]
        */
        const ob = {};
        const obb = {};

        for (let elem in results) {
            if (elem.split("=?=").length > 1) {               
                if (elem.split("=?=")[0] === 'weightfloor' ||
                    elem.split("=?=")[0] === 'countfloor' ||
                    elem.split("=?=")[0] === 'weight' ||
                    elem.split("=?=")[0] === 'height' ||
                    elem.split("=?=")[0] === 'heigWall' ||
                    elem.split("=?=")[0] === 'widthWallF' ||
                    elem.split("=?=")[0] === 'heigWallF' ||
                    elem.split("=?=")[0] === 'col') {
                    if (!ob[elem.split("=?=")[2]]) ob[elem.split("=?=")[2]] = [];
                    ob[elem.split("=?=")[2]].push({
                        [`${elem.split("=?=")[0]}=?=${elem.split("=?=")[1]}`]: results[elem]
                    });
                }
            }
        }

        const valueFields = (name, elem) => String(Object.keys(elem)).includes(name) ? Object.values(elem) : '';

        for (let el in ob) {
            obb[el] = [];
            const arrValTop = [];
            const arrValOpening = {};

            ob[el].filter((elems, index, arrgs) => {
                let idValue = String(Object.keys(elems)).split('=?=')[1];

                if (valueFields('weight=?=', elems) || valueFields('height=?=', elems) || valueFields('col=?=', elems)) {
                    if (Object.keys(arrValOpening).length === 0 || !Object.keys(arrValOpening).includes(idValue)) arrValOpening[idValue] = [];

                    if (Object.keys(arrValOpening).includes(idValue)) {
                        if (arrValOpening[idValue].length === 0) {
                            arrValOpening[idValue].push(valueFields(String(Object.keys(elems)).split('=?=')[0], elems))
                        } else {
                            arrValOpening[idValue][0] = arrValOpening[idValue][0] * valueFields(String(Object.keys(elems)).split('=?=')[0], elems)
                        }
                    }
                }
            });

            ob[el].filter((elems, index, arrgs) => {
                let weightFloors = valueFields('weightfloor=?=', elems);
                let countFloor = valueFields('countfloor=?=', elems);

                if (weightFloors) {
                    if (arrValTop.length === 0) {
                        arrValTop.push(weightFloors);
                        obb[el].push({ 'top': [] });
                    } else {
                        arrValTop[0] = arrValTop[0] * weightFloors;
                    }
                }
                if (countFloor) {
                    if (arrValTop.length === 0) {
                        arrValTop.push(countFloor);
                    } else {
                        arrValTop[0] = arrValTop[0] * countFloor;
                    }
                }
            

                if (valueFields('heigWall', elems) || valueFields('widthWallF', elems) || valueFields('heigWallF', elems)){
                    if (arrValTop.length === 0) {
                        arrValTop.push(valueFields(String(Object.keys(elems)).split('=?=')[0], elems));
                        obb[el].push({ 'top': [] });
                    } else {
                        arrValTop[0] = arrValTop[0] * valueFields(String(Object.keys(elems)).split('=?=')[0], elems);
                    }
                }
            });

            obb[el][0] = arrValTop;
            obb[el][1] = arrValOpening;
            // if (arrValOpening.length > 0){
            //     obb[el][d + 1]['opening'] = arrValOpening;
            // }
        }
        return obb;
    }

    handlingData(results, flageType, resultMansard) {
        let resPloshad = [];
        let resProjem = [];
        let resFloor = this.returnObjectValue(results);

        for (let res in resFloor) {
            resFloor[res].filter(el => {
                if (Array.isArray(el)) {
                    resPloshad.push(el);
                } else {
                    resProjem.push(Object.values(el));
                }
            });
        }

        if (resProjem[resProjem.length - 1] === undefined) return;
        let r = resProjem.map(el => {
            if (el.length === 0) return false;
            return el.reduce((accum, counter) => parseFloat(accum) + parseFloat(counter))
        });

        let sumFloor = r.reduce((accum, counter) => parseFloat(accum) + parseFloat(counter));
        let sumPloshad = resPloshad.reduce((accum, counter) => parseFloat(accum) + parseFloat(counter));

            

        return [sumPloshad, sumFloor];
    }

    handlingMansard(props){
        let [heigWall, widthWallF, heigWallF] = [];
        for (let res in props.resultMansard){
            switch (res.split("=?=")[0]){
                case 'heigWall':
                    heigWall = props.resultMansard[res];
                    break;
                case 'widthWallF':
                    widthWallF = props.resultMansard[res];
                    break;
                case 'heigWallF':
                    heigWallF = props.resultMansard[res];
                    break;
                default:
                    break;
            }
          
            
        }
        return [heigWall, widthWallF, heigWallF]
    }


    retNumb(props){
        let sumMansardFloor = [];
        if (props.resFloorMansard !== undefined)  {
            let arrVal = Object.values(props.resFloorMansard);
            if (arrVal[0]){
                let getValArr = arrVal[0][1];
                for (let res in getValArr){
                    if (sumMansardFloor.length === 0){
                        sumMansardFloor.push(parseFloat(getValArr[res]))
                    }
                    sumMansardFloor[0] = parseFloat(sumMansardFloor[0]) + parseFloat(getValArr[res]);
                }               
            }
        }

        return sumMansardFloor;
     }

    calculation(flageType, results, resultMansard) {
        if (!this.resultData) return;
        let dlina = results.dlina;
        let shirina = results.shirina;
        let dlinaV = results.dlinaV;
        let tolshinaN = (results.tolshinaN / 1000);
        let tolshinaV = (results.tolshinaV / 1000);
        let tolshinaP = (results.tolshinaP / 100);
        let dlinaOb = results.dlinaOb;

        let resFloorMansard = this.returnObjectValue(resultMansard);
        let sumProjemMansard = Number(this.retNumb({resFloorMansard}));
        let [heigWall, widthWallF, heigWallF] = this.handlingMansard({resultMansard});

        let resMons = ((dlina * 2) + (shirina * 2)) * heigWall;
        let resFrontony = (widthWallF / 2) * heigWallF;
        let calcMansard = ((resMons + resFrontony) - sumProjemMansard) * tolshinaN;

        if (!this.handlingData(results, flageType, resultMansard)) return;
        let [dataPloshad, dataFloor] = this.handlingData(results, flageType, resultMansard);

        let objemPer = ((dlinaOb * tolshinaP) * tolshinaN).toFixed(2); // Объем блоков на перегородки

        let ploshad = ((((dlina * 2) + (shirina * 2)) * (dataPloshad ? dataPloshad : 1)) - (dataFloor ? dataFloor : 0));

        let result = (((ploshad) - dlinaV) * tolshinaN);

        if (calcMansard){
            result += calcMansard;
        }

        return [result, objemPer];


    }
}

export const clGen = new General();